export enum StatusOrcamento {
    APROVADO = 'APROVADO',
    NEGADO = 'NÃO AUTORIZADO',
    ANALISE = 'ANÁLISE',
    TODOS = "TODOS",
    FINALIZADO = "FINALIZADO",
    EXECUCAO = "EXECUÇÃO",
    DIVERGENCIA = "DIVERGÊNCIA",
    COTACAO = "COTAÇÃO",
    PERDA_TOTAL = "PERDA TOTAL",
    AUSENTE = "AUSENTE",
    AGUARDANDO = "AGUARDANDO",
    PENDENTE = "PENDENTE",
    PENDENTE_DISTRIBUICAO = "PENDENTE DISTRIBUICAO"
}